"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useArrowOnlyNavigation = exports.getPreviousEl = exports.getNextEl = exports.default = void 0;
var _react = require("react");
var _tabbable = require("tabbable");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
const getPreviousEl = tabbableEls => {
  // all tabbable elements in the DOM
  const allDomEls = (0, _tabbable.tabbable)(document.body);
  if (!(allDomEls === null || allDomEls === void 0 ? void 0 : allDomEls.length)) return null;
  const firstTabbableElIdx = allDomEls.indexOf(tabbableEls === null || tabbableEls === void 0 ? void 0 : tabbableEls[0]);
  const prevIdx = firstTabbableElIdx - 1;
  if (prevIdx === -1 || prevIdx >= allDomEls.length) return null;
  // this is the first tabbable element before the containerRef.current
  return allDomEls === null || allDomEls === void 0 ? void 0 : allDomEls[prevIdx];
};
exports.getPreviousEl = getPreviousEl;
const getNextEl = tabbableEls => {
  // all tabbable elements in the DOM
  const allDomEls = (0, _tabbable.tabbable)(document.body);
  if (!(allDomEls === null || allDomEls === void 0 ? void 0 : allDomEls.length)) return null;
  const lastTabbableElIdx = allDomEls.indexOf(tabbableEls === null || tabbableEls === void 0 ? void 0 : tabbableEls[tabbableEls.length - 1]);
  const nextIdx = lastTabbableElIdx + 1;
  if (nextIdx === -1 || nextIdx >= allDomEls.length) return null;
  // this is the first tabbable element after the containerRef.current
  return allDomEls === null || allDomEls === void 0 ? void 0 : allDomEls[nextIdx];
};
exports.getNextEl = getNextEl;
const useArrowOnlyNavigation = ({
  containerRef,
  disabled
}) => {
  const [nextElState, setNextEl] = (0, _react.useState)(null);
  const handleFocus = () => {
    var _a, _b;
    if (disabled || !(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current)) return;
    const currentTabbableNodes = (0, _tabbable.tabbable)(containerRef.current);
    if (!(currentTabbableNodes === null || currentTabbableNodes === void 0 ? void 0 : currentTabbableNodes.length)) return;
    (_b = (_a = currentTabbableNodes === null || currentTabbableNodes === void 0 ? void 0 : currentTabbableNodes[0]) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  const handleNextKeydown = event => {
    if ((event === null || event === void 0 ? void 0 : event.shiftKey) && (0, _keycode.default)(event) === 'tab' && !disabled) {
      event.preventDefault();
      event.stopPropagation();
      handleFocus();
    }
  };
  const handleDocumentKeydown = event => {
    var _a, _b, _c;
    if (disabled || (0, _keycode.default)(event) !== 'tab' || !((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) return;
    // all tabbable elements in the containerRef.current
    const tabbableEls = (0, _tabbable.tabbable)(containerRef.current);
    if (!(tabbableEls === null || tabbableEls === void 0 ? void 0 : tabbableEls.length)) return;
    // we are in arrow-only navigation mode and shift+tab is pressed
    if (event === null || event === void 0 ? void 0 : event.shiftKey) {
      // find the first tabbable element in DOM immediately before the containerRef.current
      // and focus it
      const prevEl = getPreviousEl(tabbableEls);
      if (!prevEl) return;
      event.preventDefault();
      event.stopPropagation();
      (_b = prevEl.focus) === null || _b === void 0 ? void 0 : _b.call(prevEl);
    } else {
      // we are in arrow-only navigation mode and tab is pressed
      // find the first tabbable element in DOM immediately after the containerRef.current
      // and focus it
      const nextEl = getNextEl(tabbableEls);
      if (!nextEl || !(nextEl instanceof HTMLElement)) return;
      event.preventDefault();
      event.stopPropagation();
      (_c = nextEl.focus) === null || _c === void 0 ? void 0 : _c.call(nextEl);
      setNextEl(nextEl);
    }
  };
  (0, _react.useEffect)(() => {
    if (!disabled) {
      // this handles the case when shift + tab is pressed
      // on the next tabbable element after the containerRef.current
      nextElState === null || nextElState === void 0 ? void 0 : nextElState.addEventListener('keydown', handleNextKeydown);
    } else {
      nextElState === null || nextElState === void 0 ? void 0 : nextElState.removeEventListener('keydown', handleNextKeydown);
    }
    return () => {
      var _a;
      (_a = nextElState === null || nextElState === void 0 ? void 0 : nextElState.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(nextElState, 'keydown', handleNextKeydown);
    };
  }, [disabled, nextElState]);
  (0, _react.useEffect)(() => {
    if (containerRef.current && !disabled) {
      document.addEventListener('keydown', handleDocumentKeydown);
    } else {
      document.removeEventListener('keydown', handleDocumentKeydown);
    }
    return () => {
      document.removeEventListener('keydown', handleDocumentKeydown);
    };
  }, [disabled, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
};
exports.useArrowOnlyNavigation = useArrowOnlyNavigation;
var _default = exports.default = useArrowOnlyNavigation;